import React, { useCallback } from 'react';
import { useDashboardApi, useFeatureFlags } from '@splunk/dashboard-context';
import { _ } from '@splunk/ui-utils/i18n';
import { useActionButtonClick } from '../ActionButton';
import { BaseAIAssistantButton } from '../BaseAIAssistantButton';

export const AIAssistantButton = () => {
    const dashboardApi = useDashboardApi();
    const { allowDashboardAIAssistant } = useFeatureFlags();

    // this may have to select the current item if it isn't already selected
    // depending on how this should deal contextually with the ai assistant
    const openAIPanel = useCallback(() => {
        dashboardApi.openPanel({
            activePanel: 'config',
            panelProps: {
                showAIPanel: true,
            },
        });
    }, [dashboardApi]);

    const handleClick = useActionButtonClick('aiAssistant', openAIPanel);

    if (!allowDashboardAIAssistant) {
        return null;
    }

    return (
        <BaseAIAssistantButton
            title={_('Open Dashboard AI Assistant')}
            onClick={handleClick}
        />
    );
};
